import { faBars, faClose } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MenuItem from "components/common/app_menu/MenuItem";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "components/app_root/AppContext";
import MenuWrapper from "components/menu_wrapper/MenuWrapper";
import ColorLogo from "components/common/logo/ColorLogo";
import { faHeart } from "@fortawesome/pro-solid-svg-icons";
import SharingButtons from "components/sharing_buttons/SharingButtons";

const GardenMenu = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { isSmallWindow } = useContext(AppContext);
    const menuName: string = "";

    useEffect(() => {
        setIsMenuOpen(false);
    }, [isSmallWindow])

    if (!isSmallWindow) {
        return <MenuWrapper className="m-5 mr-0">
            <div className="flex flex-row pb-8 items-center justify-center">
                <ColorLogo className="w-8 h-8 mr-2" />
                <div className="cursor-default select-none">
                    <h1 className="font-bold text-xl text-main-background-tertiary">Squardener</h1>
                </div>
            </div>
            <div className=" space-y-4 text-sm flex-1 overflow-auto">
                <MenuItem to="/app/info" selected={menuName === "ZZZ"} className="flex flex-row items-center bg-main-background-secondary">
                    <FontAwesomeIcon icon={faHeart} className="mr-4 w-6 h-6 opacity-secondary text-red-600" />
                    <div className="flex-1 text-sm font-bold">You're important and can help me build Squardener!</div>
                </MenuItem>
            </div>
            <div>
                <SharingButtons />
            </div>
        </MenuWrapper>;
    }

    return <>
        <div className="absolute w-full p-2 px-5">
            <div key="title-bar" className="bg-menu-background shadow-xl font-light flex flex-row items-center text-sm rounded-md leading-10 h-10 align-baseline cursor-pointer relative" style={{ zIndex: 9 }} onClick={() => setIsMenuOpen(true)}>
                <ColorLogo className="w-6 h-6 ml-2 block opacity-50" />
                <span className="text-xs opacity-tertiary block flex-1 text-center"><span className="font-semibold">Your Gardens</span></span>
                {!isMenuOpen && <button key="open-button" className="absolute text-primary z-10 rounded-e-md right-0 leading-10 w-10 h-10 align-baseline" onClick={() => setIsMenuOpen(true)}>
                    <FontAwesomeIcon icon={faBars} />
                </button>}
            </div>
        </div>
        {isMenuOpen && <>
            <div className="absolute w-full h-full overflow-auto z-20">
                <div className="fixed inset-0 h-full w-full bg-black opacity-50" onClick={() => setIsMenuOpen(false)}></div>
                <MenuWrapper key="open-menu" className="w-full pr-12 flex-1 max-h-dvh">
                    <div className="flex flex-row pb-6 items-center justify-center">
                        <ColorLogo className="w-8 h-8 mr-2" />
                        <div className="cursor-default select-none">
                            <h1 className="font-bold text-xl text-main-background-tertiary">Squardener</h1>
                        </div>
                    </div>
                    <div className=" space-y-4 text-sm flex-1 overflow-auto">
                        <MenuItem to="/app/info" selected={menuName === "ZZZ"} className="flex flex-row items-center bg-main-background-secondary">
                            <FontAwesomeIcon icon={faHeart} className="mr-4 w-6 h-6 opacity-secondary text-red-600" />
                            <div className="flex-1 text-sm font-bold">You're important and can help me build Squardener!</div>
                        </MenuItem>
                        <SharingButtons />
                    </div>
                </MenuWrapper>
                <button key="close-button" className="text-primary fixed z-20 right-2 top-2 leading-10 w-10 h-10 align-baseline rounded-e-md" onClick={() => setIsMenuOpen(false)}>
                    <FontAwesomeIcon icon={faClose} />
                </button>
            </div>
        </>}
    </>;
}

export default GardenMenu;